import React from 'react';
import './styles.scss';

export const Http404Page: React.FC = () => {
  return (
    <div data-http404-page>
      <p>Not found page works!</p>
    </div>
  );
};